import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class ClansService extends BasicService {
    getAll() {
        return this.checkError(axios.get(this.API_URL + 'clans', { headers: authHeader() }));
    }

    getZone(name) {
        return this.checkError(axios.get(this.API_URL + 'clans/' + name + "/zone", { headers: authHeader() }));
    }

    getSingle(id) {
        return this.checkError(axios.get(this.API_URL + 'clans/' + id, { headers: authHeader() }));
    }
}

export default new ClansService();